import { render } from "./StockAndPriceStep.vue?vue&type=template&id=3d04ae64&scoped=true"
import script from "./StockAndPriceStep.vue?vue&type=script&lang=js"
export * from "./StockAndPriceStep.vue?vue&type=script&lang=js"

import "./StockAndPriceStep.vue?vue&type=style&index=0&id=3d04ae64&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d04ae64"]])

export default __exports__